export const productsDisclaimerText =
  'Product disclaimer: Lenders may launch a new Product or withdraw a Product at any time without prior notice. ' +
  'Please check directly with the lender regarding product availability and how criteria may affect this.';

export const initialProductLengthTooltip =
  `<p>The length of the product being taken out by the applicant.</p>${productsDisclaimerText}`;
